import { Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from '../../shared/services/global/global.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ENTITY_NAMES, ORGANIZATION_TYPES, RECORD_STATUS_VALUES, TABLE_OPTION_VALUES, TRAVEL_SERVICES } from '../../shared/constants/api-constants';
import { LovDataService } from '../../shared/services/lov-data/lov-data.service';
import { FilterPopoverComponent } from '../../shared/popover/filter-popover/filter-popover.component';
import { FilterService } from '../../shared/services/filter/filter.service';
import { FirebaseDatabaseService } from '../../shared/services/firebase-database/firebase-database.service';
import { ItineraryService } from 'src/app/business-service/quote/itinerary.service';
import { Observable, Subscription } from 'rxjs';
import { UniversalSearchService } from '../../shared/services/search/universal-search.service';
import { StateManagementService } from '../../shared/services/state-management/state-management.service';
import { GridViewComponent } from '../../shared/grid-view/grid-view.component';
import { CommonFormFieldsComponent } from '../../shared/popover/common-form-fields/common-form-fields.component';
import { AdminService } from 'src/app/business-service/admin/admin.service';
import { CallsService } from 'src/app/business-service/calls/calls.service';

@Component({
  selector: 'app-lead-list',
  templateUrl: './lead-list.component.html',
  styleUrls: ['./lead-list.component.scss'],
})
export class LeadListComponent implements OnInit {

  @ViewChild(GridViewComponent) gridViewComponent!: GridViewComponent;

  // Subscriptions
  private searchSubscription: Subscription | undefined;
  private subscribeToClientsEvent: Subscription | undefined;


  allLeadsData: any = {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };

  originalLeadList: any;

  allLeadsDataColumns: any = [
    {
      key: "leadId",
      colName: "Lead ID",
      showColumn: true,
      cssClass: "id-column",
      isDisabled: true,
      sortColumn: true,
      emitRowOnClick: true
    },
    {
      key: "fullName",
      colName: "Lead Name",
      showColumn: true,
      isDisabled: true,
      type: "personName",
      sortColumn: true
    },
    {
      key: "clientId",
      colName: "Client ID",
      showColumn: false,
      cssClass: "id-column",
      routePath: "/clients/details/",
      sortColumn: true
    },
    {
      key: "fullPhoneNumber",
      colName: "Phone Number",
      showColumn: true,
      cssClass: "phone-number-column",
      isDisabled: true,
      type: "phoneNumber"
    },
    {
      key: "fullALtPhoneNumber",
      colName: "Alt Phone Number",
      showColumn: false,
      cssClass: "phone-number-column"
    },
    {
      key: "priority",
      colName: "Priority",
      showColumn: false,
    },
    {
      key: "email",
      colName: "Email",
      showColumn: false,
    },
    {
      key: "leadType",
      colName: "Type",
      showColumn: true,
    },
    {
      key: "travelServices",
      colName: "Service Type",
      showColumn: true,
      isDisabled: true
    },
    {
      key: "ownershipName",
      colName: "Assigned To",
      showColumn: true,
    },
    {
      key: "itineraryId",
      colName: "Quote Id",
      showColumn: true,
      emitRowOnClick: true,
      sortColumn: true
    },
    {
      key: "destinations",
      colName: "Destinations",
      showColumn: true,
      type: "locationIcon"
    },
    {
      key: "travelDate",
      colName: "Start Date",
      showColumn: false,
      formatter: "date: MMM d, yyyy",
      sortColumn: true
    },
    {
      key: "travelEndDate",
      colName: "End Date",
      showColumn: false,
      formatter: "date: MMM d, yyyy",
      sortColumn: true
    },
    {
      key: "createDate",
      colName: "Created Date",
      showColumn: false,
      formatter: "date: MMM d, yyyy - h:mm a",
      sortColumn: true
    },
    {
      key: "createdBy",
      colName: "Created By",
      showColumn: true,
    },
    {
      key: "modifiedDate",
      colName: "Modified Date",
      showColumn: false,
      formatter: "date: MMM d, yyyy - h:mm a",
      sortColumn: true
    },
    {
      key: "modifiedBy",
      colName: "Modified By",
      showColumn: false,
    },
    {
      key: "source",
      colName: "Lead Source",
      showColumn: false,
    }
  ];
  leadOptionsValues: any = {
    idKey: "leadId",
    options: [
      {
        value: "View",
        path: TABLE_OPTION_VALUES.VIEW
      },
      {
        value: "Edit",
        path: TABLE_OPTION_VALUES.EDIT
      },
      {
        value: "Create Task",
        path: TABLE_OPTION_VALUES.TASK
      },
      {
        value: "Delete",
        path: TABLE_OPTION_VALUES.DELETE
      }
    ]
  };

  // filters
  leadFilters: any = { "travelServices": [], "status": [], "ownership": [], "source": [], "priority": [], "createdBy": [], "startDate": [], "endDate": [], "type": [] };
  // Pagination settings
  paginationSettings: any = {
    pageNumber: 1,
    pageSize: 10
  }

  ENTITY_NAMES = ENTITY_NAMES;
  RECORD_STATUS_VALUES = RECORD_STATUS_VALUES;
  ORGANIZATION_TYPES = ORGANIZATION_TYPES;

  leadStatusLov: any;
  showFilters: boolean = false;

  // date range
  fromDate!: string;
  toDate!: string;

  leadFilterStatusLov: any = [];
  activeVisibleStatusFilters: any[] = [];
  moreVisibleStatusFilters: any[] = [];

  organizationType: string = localStorage.getItem("CType") || '';

  constructor(
    private _popoverController: PopoverController,
    private _leadServices: LeadsService,
    private _globalService: GlobalService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _responseNotificationService: ResponseNotificationService,
    private _modalPopupService: ModalsService,
    private _reloadService: ComponentReloadService,
    private _lovDataService: LovDataService,
    private _callsService: CallsService,
    private _filterService: FilterService,
    private _firebaseDbService: FirebaseDatabaseService,
    private _itineraryService: ItineraryService,
    private _universalSearchService: UniversalSearchService,
    private _stateManagementService: StateManagementService,
    private _adminService: AdminService
  ) { }

  role: any;
  showLeadButton: boolean = true;
  leadPermissions: any;
  hideTaskButton: any;
  packageIds: any;

  async ngOnInit() {
    this.handleColumnBasedOnOrganizationType();

    this.allLeadsDataColumns = this._stateManagementService.getTableColumns(ENTITY_NAMES.LEAD)?.length ? this._stateManagementService.mergeManageColumnsStates(this._stateManagementService.getTableColumns(ENTITY_NAMES.LEAD), this.allLeadsDataColumns) : this.allLeadsDataColumns;
    let storedFilters = this._stateManagementService.getFilters(ENTITY_NAMES.LEAD);
    if (storedFilters) {
      let updatedFilters: any = {};

      for (const key in storedFilters) {
        if (storedFilters.hasOwnProperty(key) && storedFilters[key].length > 0) {
          if (key === "ownership") {
            let ownershipData = await this.getColumnData(ENTITY_NAMES.USER, "name");
            updatedFilters[key] = ownershipData.filter((ownership: any) => storedFilters[key].includes(ownership.data));
          } else {
            updatedFilters[key] = storedFilters[key].map((item: any) => ({ key: item, data: item }));
            if (key === "startDate") {
              this.fromDate = updatedFilters[key][0]?.key || '';
            }
            if (key === "endDate") {
              this.toDate = updatedFilters[key][0]?.key || '';
            }
          }
        }
      }

      this.leadFilters = {
        ...this.leadFilters,
        ...updatedFilters
      };
    }

    let organization = await this._globalService.getLoggedInOrgDetails();
    this.packageIds = organization.organizationDetails.packageId;
    await this.updateActionsForRoles();

    this.leadStatusLov = await this.getLovData(ENTITY_NAMES.LEAD_STATUS);
    this.leadFilterStatusLov = await this.getColumnData(ENTITY_NAMES.LEAD_STATUS, "name");
    
    this.leadStatusLov = this.leadStatusLov.map((item: any) =>
      item.key === RECORD_STATUS_VALUES.IN_PROGRESS || item.key === RECORD_STATUS_VALUES.QUOTE_CREATED || item.key === RECORD_STATUS_VALUES.CONVERTED || item.key === RECORD_STATUS_VALUES.TRIP_COMPLETED ? { ...item, disabled: true } : item
    );

    this.subscribeToClientsEvent = this._firebaseDbService.subscribeToClientsEvent().subscribe((data: any) => {
      this.getDefaultLeads();
    }, error => {
      console.error('Error fetching data:', error);
    });


    this.searchSubscription = this._universalSearchService.searchValueChanged.subscribe(() => {
      this.getDefaultLeads();
    });

    this._reloadService.reloadLeads$.subscribe(() => {
      this.getDefaultLeads();
    });
  }

  handleColumnBasedOnOrganizationType() {
    const orgType = localStorage.getItem("CType");
    if(orgType != ORGANIZATION_TYPES.AGENT_AND_DMC){
      this.allLeadsDataColumns = this.allLeadsDataColumns.filter((column: { key: string; }) => column.key !== 'leadType');
    }
  }

  manageColumnsChanged(event: any) {
    this._stateManagementService.setTableColumns(ENTITY_NAMES.LEAD, event)
  }

  async getLovData(catogory: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this._lovDataService.getLovData(catogory).subscribe((data) => {
        resolve(data);
      }, (error) => {
        reject(error);
      });
    })
  }

  // date range 
  onFromDateChange(event: any) {
    if (this.toDate && new Date(this.toDate) < new Date(event)) {
      this.toDate = ''; // Reset toDate if it's less than fromDate
    }

    if (!event) {
      this.toDate = '';
    }
    this.leadFilters.startDate = [this.fromDate];
    this.setFiltersState();

    this.getDefaultLeads();

  }

  onToDateChange(event: any) {
    this.leadFilters.endDate = [this.toDate];
    this.setFiltersState();

    this.getDefaultLeads();
  }

  get today() {
    return this._globalService.getTodaysDate();
  }
  // date range


  clearFilters() {
    // match the structure with the initial value
    this.leadFilters = { "travelServices": [], "status": [], "ownership": [], "source": [], "priority": [], "createdBy": [], "startDate": [], "endDate": [], "destination": [] };
    this.setFiltersState();
    this.fromDate = '';
    this.toDate = '';
    this.getDefaultLeads();
  }

  setFiltersState() {
    this._stateManagementService.setFilters(ENTITY_NAMES.LEAD, this._globalService.convertDataToStrings(this.leadFilters));
  }

  async openFiltersPopup(event: Event, columnName: string, entityName: string, otherColumnName: any) {
    let listOfValues: any = [];
    listOfValues = await this.getColumnData(entityName, columnName);
    listOfValues = listOfValues.map((item: { key: string; data: any }) => ({
      key: item.key,
      data: item.data,
    }));


    if (listOfValues) {
      const emitCheckedItems = new EventEmitter<any[]>();
      const popover = await this._popoverController.create({
        component: FilterPopoverComponent,
        event: event,
        cssClass: 'filter-popover-component',
        componentProps: {
          entityName: entityName,
          listOfValues: listOfValues,
          columnName: columnName,
          checkedListOfValues: otherColumnName ? this.leadFilters[otherColumnName] : this.leadFilters[columnName],
          emitCheckedItems: emitCheckedItems
        }
      });

      emitCheckedItems.subscribe((checkedItems: any) => {
        if (otherColumnName) {
          this.leadFilters[otherColumnName] = checkedItems;
        }
        else {
          this.leadFilters[columnName] = checkedItems;
        }
        this.setFiltersState();
        this.getDefaultLeads();

      })
      return await popover.present();
    }
  }

  async getColumnData(entityName: string, columnName: string): Promise<any> {
    try {
      var response: any;
      if(entityName == 'type'){
        response = [
          { data: ORGANIZATION_TYPES.AGENT, key: "B2C" },
          { data: ORGANIZATION_TYPES.DMC, key: "B2B" }
        ]
      }else{
        response = await this._filterService.getLovColumnData(entityName, columnName, ORGANIZATION_TYPES.AGENT).toPromise();
      }      
      return response;
    } catch (error) {
      return null;
    }
  }

  getDefaultLeads() {
    this._leadServices.getAllLeads(this.paginationSettings?.pageNumber, this.paginationSettings?.pageSize, null, this._universalSearchService.getSearchValue(), this._globalService.convertDataToStrings(this.leadFilters)).subscribe(
      (allLeads) => {
        this.allLeadsData = allLeads;
        this.originalLeadList = allLeads.data;
        this.allLeadsData.data = allLeads.data.map((lead: any) => ({
          ...lead,
          fullName: lead.firstName ? `${lead.firstName} ${lead.lastName || ''}` : '--',
          personNameBadge: this._globalService.createPersonNameBadge(lead.firstName, lead.lastName),
          fullPhoneNumber: lead.phoneNumber
            ? `${lead.phoneNumber.countryCode || ''} ${lead.phoneNumber.phone || ''}`
            : '',
          fullALtPhoneNumber: lead.alternativePhoneNumber?.phone
            ? `${lead.alternativePhoneNumber?.countryCode || ''} ${lead.alternativePhoneNumber?.phone || ''}`
            : '',
          destinations: lead.destination && lead.destination?.length ? lead.destination.map((d: any) => `${this._globalService.getFirstItemOfString(d.location)}(${d.days})`) : '',
          travelServices: lead.travelServices?.includes(TRAVEL_SERVICES.TOUR_PACKAGE) ? TRAVEL_SERVICES.TOUR_PACKAGE : lead.travelServices,
          statusLov: this._globalService.filterLeadStatusLov(lead, this.leadStatusLov),
          ownershipName: lead.ownershipName ? `@${lead.ownershipName}` : "--",
          leadType: lead.type === ORGANIZATION_TYPES.AGENT ? "B2C" : "B2B",
        }));
      },
      (error) => {
        this._responseNotificationService.showMessage("Something went wrong, try again later!", true)
      }
    );
  }

  columnConfig: { key: string; title: string }[] = [
    { key: 'leadId', title: 'Lead ID' },
    { key: 'firstName', title: 'LeadName' },
    { key: 'clientId', title: 'Client ID' },
    { key: 'phoneNumber', title: 'Phone Number' },
    { key: 'priority', title: 'Priority' },
    { key: 'email', title: 'Email' },
    { key: 'travelServices', title: 'Service Type' },
    { key: 'ownershipName', title: 'Assigned To' },
    { key: 'itineraryId', title: 'Quote Id' },
    { key: 'destination', title: 'Destination' },
    { key: 'createDate', title: 'Created Date' },
    { key: 'createdBy', title: 'Created By' },
    { key: 'modifiedDate', title: 'Modified Date' },
    { key: 'modifiedBy', title: 'Modified By' },
    { key: 'source', title: 'Lead Source' },
    { key: 'status', title: 'Status' },
  ];


  downloadLeadsCSV(): void {
    this._leadServices.getAllLeads(-1, -1, null, this._universalSearchService.getSearchValue(), this._globalService.convertDataToStrings(this.leadFilters)).subscribe(
      (allLeads) => {
        // this.allLeadsData = allLeads;
        this.originalLeadList = allLeads.data;
        const moduleName = 'Leads';
        const currentDate = new Date();
        const formattedDate = `${String(currentDate.getMonth() + 1).padStart(2, '0')}${String(currentDate.getDate()).padStart(2, '0')}${currentDate.getFullYear()}`;
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}${String(currentDate.getMinutes()).padStart(2, '0')}${String(currentDate.getSeconds()).padStart(2, '0')}`;
        const fileName = `TM_${moduleName}_${formattedDate}_${formattedTime}`;

        interface Destinations {
          location: string;
        }

        const formattedData = this._globalService.formatPhoneNumber(this.originalLeadList, "phoneNumber");

        formattedData.forEach(lead => {
          if (lead.destination && Array.isArray(lead.destination) && lead.destination.length === 0) {
            lead.destination = "No Destination";
          } else if (lead.destination && Array.isArray(lead.destination) && lead.destination.length > 0) {
            try {
              const formattedDestinations = lead.destination.map((destinationObj: Destinations) => {
                let location = destinationObj.location ? destinationObj.location.trim().replace(/\s+/g, ' ').replace(/,\s*/g, ', ') : "Unknown Location";

                const cityMatch = location.split(",")[0];

                return cityMatch ? cityMatch : "Unknown City";
              });

              lead.destination = formattedDestinations.join(", ");
            } catch (e) {
              console.error('Error formatting destination:', e);
              lead.destination = "Invalid Format";
            }
          }

          if (lead.createDate) {
            try {
              lead.createDate = new Date(lead.createDate).toLocaleString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
              }).replace(',', '');
            } catch (e) {
              console.error('Error formatting createDate:', e);
              lead.createDate = "Invalid Date";
            }
          }
        });

        this._globalService.convertToCSV(formattedData, this.columnConfig, fileName);
      });
  }


  // Open new lead form
  openNewLeadForm() {
    this._modalPopupService.openLeadForm(null, null);
  }

  //  Open quote view on click from grid
  gridCellClicked(event: any) {
    let row = event.row;
    const clickedItem = event.clickedItem;
    switch (clickedItem) {
      case 'itineraryId':
        if (row.itineraryId && row.leadId) {
          this._itineraryService.getQuoteData(row.itineraryId).subscribe({
            next: (data: any) => {
              let quoteStatus = data.itineraryDetails?.status;
              if (this.leadPermissions.editQuote && quoteStatus === RECORD_STATUS_VALUES.DRAFT) {
                this._modalPopupService.openItineraryForm(row.clientId, row.leadId, row.itineraryId, null, null);
              } else {
                this._modalPopupService.openReviewItineraryView(row.itineraryId, row.leadId, row.clientId);
              }
            },
            error: (error: any) => {
              this._responseNotificationService.showMessage("Error fetching quote data.", true)
            }
          })
        }
        break;
        
      case 'leadId':
        this.viewLead(row.leadId);
        break;
    
      default:
        break;
    }
    
  }

  //  Delete lead
  async deleteLeadRow(leadId: any) {
    if (await this._globalService.confirmActionPopup(`Are you sure to delete ${leadId}`, "Confirm Delete", "Yes")) {
      this._leadServices.deleteLead(leadId).subscribe(data => {
        if (data) {
          this._responseNotificationService.showMessage("Lead Deleted Successfully.")
        }
        this.ngOnInit();
      })
    }

  }

  // Edit lead
  editLeadOpen(leadId: any) {
    this._modalPopupService.openLeadForm(leadId, null);
  }

  // View lead
  viewLead(leadId: any) {
    this._leadServices.getLead(leadId).subscribe({
       next: (data) => {
        if(data.type == ORGANIZATION_TYPES.AGENT){
          this._router.navigate(['../details', leadId], { relativeTo: this._activatedRoute });
        }else{
          this._router.navigate(['../dmc-details', leadId], { relativeTo: this._activatedRoute });
        }
      }
    })
  }

  // Create task
  createTaskForLead(leadId: any) {
    this._modalPopupService.openTasksForm(null, leadId, (goNew) => {
      if (goNew) {
        this.createTaskForLead(leadId); // Open a new form
      }
    });
  }

  // Status change from grid
  leadStatusChanged(event: any) {
    let leadData = event.row;
    // Get lead data and update
    this._leadServices.getLead(leadData.leadId).subscribe((data) => {
      leadData = data;
      leadData.status = event.statusValue;
      this._leadServices.updateLead(leadData.leadId, leadData).subscribe((data) => {
        this._reloadService.triggerLeadsReload();
      })
    })

  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  // Get all leads when paginations updated
  updatePagination(paginationData: any) {
    this.paginationSettings = paginationData;
    this.getDefaultLeads()
  }

  async updateActionsForRoles() {

    await this._globalService.roles$.subscribe((roles) => {
      if (roles) {
        const leadsModule = roles.modules.find((module: any) => module.name === "Leads");
        this.leadPermissions = leadsModule.permissions;

        // resetting options to empty array
        this.leadOptionsValues.options = [];

        // Appending respective options according to role permissions
        if (this.leadPermissions.viewLead) {
          this.leadOptionsValues.options.push({
            value: "View",
            path: TABLE_OPTION_VALUES.VIEW
          });
        }
        if (this.leadPermissions.editLead) {
          this.leadOptionsValues.options.push({
            value: "Edit",
            path: TABLE_OPTION_VALUES.EDIT
          });
        }
        this.leadOptionsValues.options.push({ value: "Audit History", path: TABLE_OPTION_VALUES.SHOW_AUDIT });
        if (this.leadPermissions.deleteLead) {
          this.leadOptionsValues.options.push({
            value: "Delete",
            path: TABLE_OPTION_VALUES.DELETE
          });
        }

        const taskModule = roles.modules.find((module: any) => module.name === "Tasks");
        if (!taskModule || !taskModule.permissions) {
          this.hideTaskButton = true;
        } else {
          this.hideTaskButton = !taskModule.permissions.createTask;
        }

        if (localStorage.getItem("Role") !== "ClientAccountant" && !this.hideTaskButton) {
          this.leadOptionsValues.options.push({
            value: "Create Task",
            path: TABLE_OPTION_VALUES.TASK
          });
        }

      }
    })
  }

  async deleteMultipleRow() {
    if (await this._globalService.confirmActionPopup("Are you sure to delete multiple leads at once?", "Confirm multi delete", "Yes")) {
      let selectedRows = this.gridViewComponent.getSelectedRows();
      let selecteRows = selectedRows.map((row: any) => row.leadId);

      if (selecteRows && selecteRows.length) {
        let req = {
          ids: selecteRows,
          actions: {
            isDeleted: true
          }
        }

        this._leadServices.performBulkActions(req).subscribe({
          next: (res) => {
            this._reloadService.triggerLeadsReload();
            this._responseNotificationService.showMessage("Leads deleted successfully");
          }
        })
      }
    }
  }

  async openCommonFieldsForm(event: any) {
    const status = this.leadStatusLov;
    const priorities = await this.getLovData("TaskPriority");

    const popover = await this._popoverController.create({
      component: CommonFormFieldsComponent,
      event: event,
      cssClass: 'common-form-fields-popover',
      componentProps: {
        status: status,
        priorities: priorities,
        onFormSubmitted: (data: any) => this.performBulkUpdate(data),
      }
    });

    return await popover.present();
  }

  async performBulkUpdate(data: any) {
    console.log(data);
    const ownership = data.ownership || null;
    const status = data.status || null;
    const priority = data.priority || null;

    if (await this._globalService.confirmActionPopup("Are you sure to update multiple leads at once?", "Confirm multi update", "Yes")) {
      let selectedRows = this.gridViewComponent.getSelectedRows();
      let selecteRows = selectedRows.map((row: any) => row.leadId);

      if (selecteRows && selecteRows.length) {
        let req = {
          ids: selecteRows,
          actions: {
            ...(ownership ? { ownership: ownership } : {}),
            ...(status ? { status: status } : {}),
            ...(priority ? { priority: priority } : {})

          }
        }

        this._leadServices.performBulkActions(req).subscribe({
          next: (res) => {
            this._reloadService.triggerLeadsReload();
            this._responseNotificationService.showMessage("Leads updated successfully");
          }
        })
      }
    }
  }

  async bulkUploadLeads() {
    const config: any = {
      moduleName: 'Leads',
      fields: [
        { label: 'First Name', property: 'firstName' },
        { label: 'Last Name', property: 'lastName' },
        { label: 'Phone Country Code', property: 'countryCode' },
        { label: 'Phone Number', property: 'phoneNumber' },
        { label: 'Email', property: 'email' },
        { label: 'Lead Source', property: 'source' },
        { label: 'Planned Travel Month', property: 'plannedTravelMonth' },
        { label: 'City Of Residence', property: 'cityOfResidence' },
        { label: 'Interested Package', property: 'preferredPackage' },
      ]
    };
    let res = await this._modalPopupService.openBulkUploadModal(config, "Kindly ensure that both the lead name and phone number fields are completed in the uploaded Excel file, as these are required for successful processing.");
    if (res?.mappedData) {
      res.mappedData.forEach((data: any) => {
        if (data.phoneNumber && data.countryCode) {
          data.phoneNumber = { phone: data?.phoneNumber, countryCode: data?.countryCode };
        }
        if (data.alternativePhoneNumber && data.alternativePhoneNumber !== '') {
          data.alternativePhoneNumber = { phone: data.alternativePhoneNumber, countryCode: data.countryCode };
        }
        data.type = ORGANIZATION_TYPES.AGENT;
      });

      // Validation: firstName and phoneNumber.phone must not be empty
      const invalidRows = res.mappedData.filter((data: any) => {
        return !data.firstName || !data.phoneNumber || !data.phoneNumber.phone;
      });

      if (invalidRows.length > 0) {
        this._globalService.customAlert("Each lead must have a First Name and Phone Number.", "Invalid Data")
        return;
      }

      this._leadServices.bulkUploadLeads(res.mappedData).subscribe({
        next: (res) => {
          this._responseNotificationService.showMessage("Leads uploaded successfully!");
          this._reloadService.triggerLeadsReload();
        },
        error: (err) => {
          this._responseNotificationService.showMessage("Error uploading leads, please try again.", true);
        }
      })
    }
  }
  showAuditHistory(id: any) {
    this._lovDataService.getAuditData(id, "Lead").subscribe((data) => {
      if (data && data.data) {
        // Filter changes inside each record
        data.data = data.data.map((record: any) => {
          return {
            ...record,
            changes: record.changes.filter((change: any) => {
              return change.field === 'Source' ||
                change.field === 'Alternate Phone Number' ||
                change.field === 'Alternate Country Code' ||
                change.field === 'Phone Number' ||
                change.field === 'Country Code' ||
                change.field === 'itineraryId' ||
                change.field === 'Priority' ||
                change.field === 'Status' ||
                change.field === 'Email ID' ||
                change.field === 'salutation' ||
                change.field === 'First Name' ||
                change.field === 'Last Name' ||
                change.field === 'Lead Notes' ||
                change.field === 'Company Name' ||
                change.field === 'Assign Ownership' ||
                change.field === 'Created By' ||
                change.field === 'Created Date' ||
                change.field === 'Modified By' ||
                change.field === 'Modified Date' ||
                change.field === 'Deleted';
            })
          };
        });
      }
      this._modalPopupService.openAuditHistoryView(ENTITY_NAMES.LEAD, id, data, `Lead (${id})`);
    });
  }

  getStatusCount(status: string): number {
    const statusObj = this.leadFilterStatusLov.find((item: any) => item.key === status);
    return statusObj ? statusObj.count : 0;
  }

  async openMoreStatusDropdown(event: Event) {
    let listOfValues: any = [];

    listOfValues = this.leadFilterStatusLov
                    .filter((item: any) => 
                      item.key !== RECORD_STATUS_VALUES.CONTACTED && item.key !== 
                      RECORD_STATUS_VALUES.NEW && item.key !== 
                      RECORD_STATUS_VALUES.IN_PROGRESS && item.key !== 
                      RECORD_STATUS_VALUES.TRIP_COMPLETED && item.key !== 
                      RECORD_STATUS_VALUES.ON_HOLD);

    if (listOfValues) {
      const emitCheckedItems = new EventEmitter<any[]>();
      const popover = await this._popoverController.create({
        component: FilterPopoverComponent,
        event: event,
        cssClass: 'filter-popover-component',
        componentProps: {
          entityName: ENTITY_NAMES.LEAD_STATUS,
          listOfValues: listOfValues,
          columnName: "name",
          checkedListOfValues: this.moreVisibleStatusFilters,
          emitCheckedItems: emitCheckedItems
        }
      });

      emitCheckedItems.subscribe((checkedItems: any) => {
        this.moreVisibleStatusFilters = checkedItems;
        // ensure activeVisibleStatusFilters is an array and merge correctly
        this.leadFilters['status'] = [...this.activeVisibleStatusFilters, ...this.moreVisibleStatusFilters];
        this.getDefaultLeads();
      })
      return await popover.present();
    }
  }

  toggleStatusFilter(status: string) {
    const statusObj = this.leadFilterStatusLov.find((item: any) => item.key === status);
    if (this.activeVisibleStatusFilters.includes(statusObj)) {
      this.activeVisibleStatusFilters = this.activeVisibleStatusFilters.filter((item: any) => item.key !== statusObj.key);
    } else {
      this.activeVisibleStatusFilters.push(statusObj);
    }
    this.leadFilters['status'] = this.activeVisibleStatusFilters;
    this.getDefaultLeads();
  }

  checkIfStatusActive(status: string): boolean {
    const statusObj = this.leadFilterStatusLov.find((item: any) => item.key === status);
    return this.activeVisibleStatusFilters.includes(statusObj);
  }

  toggleAllStatusFilters() {
    this.activeVisibleStatusFilters = [];
    this.moreVisibleStatusFilters = [];
    this.leadFilters['status'] = [];
    this.getDefaultLeads();
  }

  isAllStatusFiltersActive(): boolean {
    if(this.activeVisibleStatusFilters.length === 0 && this.moreVisibleStatusFilters.length === 0) {
      return true;
    }else {
      return false;
    }
  }

  openLeadWhatsappNumber(event:any){
    const row = event;
    const phone = `${row.phoneNumber.countryCode}${row.phoneNumber.phone}`
    this._globalService.openNumberWhatsappWeb(phone)
  }
  openLeadEmail(event:any){
    const email = event.email;
    if(!email){
      this._responseNotificationService.showMessage("This lead does'nt contain email!", true);
      return;
    }
    this._globalService.openEmailApp(email);
  }

  async sendCallNotification(event: any) {
    const row = event;
    if (!row.phoneNumber?.phone) {
      this._responseNotificationService.showMessage("This lead does'nt contain a phone number!", true);
      return;
    }
    if(await this._globalService.confirmActionPopup(`Are you sure to call ${row.fullName} from Mobile?`, "Confirm Call Initialization", "Call Now")) {
      this._callsService.addCallNotification(row.leadId, row.phoneNumber).subscribe({
        next: () => {
          this._responseNotificationService.showMessage("Call Initiated, please check your mobile");
        },
        error: () => {
          this._responseNotificationService.showMessage("Failed to send call notification, please try again.", true);
        }
      });
    }    
  }

  ngOnDestroy() {
    this.searchSubscription?.unsubscribe();
    this.subscribeToClientsEvent?.unsubscribe();
  }
}
